"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=designation.dto.js.map